<template>
  <div class="ruKuZuoyeWarp">
    <div class="ruKuZuoyeWarp-body">
      <div class="detailsTitle">
        <h4>到货预报明细</h4>
        <div @click="backClick"><i class="fa fa-reply"></i></div>
      </div>
      <!-- 查询条件 -->
      <div ref="searchBox" class="formBox margbot">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="95px" size="mini" style="width: 100%;">
          <div class="formItemBox">
          <el-form-item label="货物类型:">
            <el-select filterable clearable v-model="formData.productType" size="mini" placeholder="请选择货物类型">
              <el-option v-for="(item,index) in huowuOptions" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select filterable clearable v-model="formData.steelMillName" size="mini" placeholder="请选择产地">
              <el-option v-for="(item,index) in chanDiOptions" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select filterable clearable v-model="formData.specification" size="mini" placeholder="请选择规格">
          <el-option v-for="(item,index) in guigeOptions" :key="index" :label="item" :value="item"></el-option>
         </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select filterable clearable v-model="formData.model" size="mini" placeholder="请选择材质">
              <el-option v-for="(item,index) in caiZhiOptions" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
         </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP004B008" v-if="btnFlg[7]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP004B009" v-if="btnFlg[8]">重置</el-button>
            <el-button type="primary" size="mini" @click="xinzeng" btnCode="00cP004B00A" v-if="btnFlg[9]">新增</el-button>
            <el-button type="primary" size="mini" @click="shanchu" btnCode="00cP004B00B" v-if="btnFlg[10]">删除</el-button>
          </el-form-item>
           <el-form-item>
            <span>&nbsp;
              总吨数:
            <span style="color: red">{{ allPlanWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ allPlanNumber }}</span> &nbsp;件
            </span>
           </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div :style="{ height: h }" v-loading='tabLoading'>
        <el-table
        height="100%"
        size="mini"
        border
        center
        bordersize="mini"
        ref="tableData"
        :data="tableData"
        style="width: 100%"
        class="elTab"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        highlight-current-row
        @row-click="dianjixuanzhong"
      >
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" align="center" ></el-table-column>
        <el-table-column prop="steelMillName" label="产地" align="center" ></el-table-column>
        <el-table-column prop="specification" label="规格" align="center" ></el-table-column>
        <el-table-column prop="model" label="材质" align="center" ></el-table-column>
        <el-table-column prop="warehouseName" label="仓位" align="center" ></el-table-column>
        <el-table-column prop="planNumber" label="计划件数" align="center" width="120"></el-table-column>
        <el-table-column prop="planWeight" label="计划重量(吨)" align="center" width="120"></el-table-column>
        <el-table-column prop="actualNumber" label="实入件数" align="center" width="110"></el-table-column>
        <el-table-column prop="actualWeight" label="实入重量(吨)" align="center" width="120"></el-table-column>
        <el-table-column prop="forecastSingletonWeight" label="预报件重(吨/件)" align="center" width="150"></el-table-column>
      </el-table>
      </div>
      <div class="pags" style="text-align: left">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="formData.pageNo"
          :page-size="formData.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- dialogs -->
    <!-- 新增货物信息 -->
    <add-details v-if="xzVisible" :xzVisible.sync="xzVisible" :title="xzTitle" :xztableData="xztableData" :shipForecastMasterId="formData.shipForecastMasterId" :RKData.sync='RKData'></add-details>
    <!-- 卸车确认 -->
    <xie-che-dialog v-if="xcVisible" :xcVisible.sync='xcVisible'></xie-che-dialog>
  </div>
</template>

<script>
import {
  removeSummary, // 删除
  getSummaryList, // 列表查询
  getSummaryDropDown, // 查询条件
  getSummaryPlanWeightAndPiece
} from '@/api/wms-access'
import {
  getRelationCustomer,
  getVirtualBalingList
} from '@/api/wms-stock'
import {
  dateTimeFormat,
  dateFormat
} from '@/utils/util'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import addDetails from './addDetails.vue'
import XieCheDialog from './xieCheDialog.vue'

export default {
  components: { addDetails, XieCheDialog },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      dateFormat: dateFormat,
      formData: {
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        pageNo: 1,
        pageSize: 20,
        shipForecastMasterId: this.$route.query.shipForecastMasterId
      },
      huowuOptions: [],
      chanDiOptions: [],
      guigeOptions: [],
      caiZhiOptions: [],
      total: 0,
      RKData: [], //
      btnFlg: [],
      tableData: [],
      allPlanNumber: 0,
      allPlanWeight: 0,
      btnIdArr: [
        '00cP004B001',
        '00cP004B002',
        '00cP004B003',
        '00cP004B004',
        '00cP004B005',
        '00cP004B006',
        '00cP004B007',
        '00cP004B008',
        '00cP004B009',
        '00cP004B00A',
        '00cP004B00B'
      ],
      detailsH: '200px',
      h: '500px',
      xuanzhongArr: null,
      xzVisible: false,
      xzTitle: '新增货物',
      xztableData: [],
      xcVisible: false,
      tabLoading: false
    }
  },
  methods: {
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    xinzeng () {
      this.xzVisible = true
      this.xzTitle = '新增预报'
    },
    shanchu () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeSummary(this.xuanzhongArr.shipForecastSummaryId)
          .then(res => {
            DonMessage.success('删除成功')
            that.chaxun()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    chaxun () {
      this.tabLoading = true
      getSummaryList(this.formData)
        .then(res => {
          this.tabLoading = false
          this.tableData = res.list
          this.total = res.total
          if (res.list.length > 0) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => {
              this.$refs.tableData.setCurrentRow(res.list[0])
            })
          } else {
            this.tableData = []
          }
          this.getSummaryPlanWeightAndPiece()
        })
        .catch(error => {
          this.tabLoading = false
          DonMessage.error(error.message)
        })
    },
    chongzhi () {
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.pageNo = 1
      this.formData.pageSize = 20
      this.chaxun()
    },
    handleCurrentChange (val) {
      this.formData.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.formData.pageSize = val
      this.chaxun()
    },
    getSummaryDropDown () {
      let shipForecastMasterId = this.$route.query.shipForecastMasterId
      getSummaryDropDown(shipForecastMasterId)
        .then(res => {
          this.chanDiOptions = res.steelMillNameList
          this.guigeOptions = res.specificationList
          this.caiZhiOptions = res.modelList
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    getVirtualBalingLists () {
      getVirtualBalingList(
        this.selectObj
      )
        .then(res => {
          let productArr = []
          res.forEach(item => {
            let obj = {}
            obj.id = item.productType
            obj.name = item.productTypeName
            productArr.push(obj)
          })
          const ress = new Map()
          let arrNew = productArr.filter((arr) => !ress.has(arr.id) && ress.set(arr.id, 1))
          this.huowuOptions = arrNew
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 获取总吨数，总件数
    getSummaryPlanWeightAndPiece () {
      getSummaryPlanWeightAndPiece(this.formData)
        .then(res => {
          this.allPlanNumber = res.allPlanNumber
          this.allPlanWeight = res.allPlanWeight
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    backClick () {
      this.$router.go(-1)
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycChuanYun')
    this.chaxun()
    this.getSummaryDropDown()
    this.getVirtualBalingLists()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 210 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox{
  .el-form-item{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.ruKuZuoyeWarp {
  width: 100%;
  position: relative;
}
    /deep/.detailsTitle{
  margin-bottom: 0;
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
</style>
